import commonApi from "@api/common";
import { useLayoutContext } from "@context/layout";
import {
  PRODUCT_SLUG,
  HOME_EXPERIMENT_LOCATIONS,
  TAG_EXPERIMENT,
} from "@types";
import { useRouter } from "next/router";

const useHomeExperiments = () => {
  const layoutData = useLayoutContext();
  const { pathname } = useRouter();

  const commonSendingData = {
    tag: TAG_EXPERIMENT.HOME_AGE_ORDER_ACTION,
    is_login: Boolean(layoutData?.userData?.is_login),
    user_id: layoutData?.userData?.user_id || null,
    age: layoutData?.userData?.user?.age || null,
    product_count: layoutData?.userData?.user?.num_order,
    product_count_free: layoutData?.userData?.user?.num_free_order,
  };

  const homeExperimentSubmitter = async (additionalData: {
    location?: HOME_EXPERIMENT_LOCATIONS;
    name?: PRODUCT_SLUG;
    order?: number;
  }) => {
    try {
      if (
        pathname === "/" &&
        additionalData?.name &&
        additionalData?.location
      ) {
        const { tag, ...otherData } = commonSendingData;
        const res = await commonApi
          .submitLog({
            tag,
            anyJoson: {
              ...otherData,
              ...additionalData,
              version: "dynamic-v1",
            },
          })
          .fetch();
        return res;
      }
    } catch (error) {
      console.log(error);
    }
  };

  return homeExperimentSubmitter;
};

export default useHomeExperiments;
